export const readableText = (value?: string | null): string => {
  if (!value) {
    return "-";
  }

  return value
    .replaceAll("_", " ")
    .replaceAll("-", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
